import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'

import colors from '../../assets/js/colors'
import facebookLogo from '../../assets/img/facebook-square-white.svg'

const Wrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=PT+Sans+Caption:400,700');
  
  font-family: 'PT Sans Caption', sans-serif;
	padding: 0 2rem 2rem 2rem;
	display: flex;
	justify-content: center;
	flex-direction: column;
	min-height: 100%;	
	position: absolute; // required for min-height to work, not sure why
	color: ${colors.facebook}
`

const Header = styled.h1`
  margin: 0 0 1rem 0;
`

const Subheader = styled.h2`
  margin: 0 0 3rem 0;
  font-weight: normal;
  color: ${colors.gray}
`

const Text = styled.p`
  margin: 0 0 2rem 0;
  white-space: pre-wrap;
`

const List = styled.ul`
  margin: 0 0 3rem 0;
  border-left: solid .5px;
  padding-left: 1rem;
  padding-right: 1rem;
`

const Item = styled.li`
  display: block;
  margin: 1rem 0;
`

const Button = styled.a.attrs({
  target: '_blank'
})`
  color: white;
  border-radius: 5px;
	background-color: ${colors.facebook};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  
  img {  
    margin-left: 1rem;
    height: 30px;
  }
`

const FacebookLinkTemplate = ({header, subheader, text, list, link, buttonText}) =>
  <Wrapper>
    <Fade bottom ssrReveal>
      <div>
        {header && <Header>{header}</Header>}
        {subheader && <Subheader>{subheader}</Subheader>}
        {text && <Text>{text}</Text>}
        {list && <List>{list.map((item, index) => <Item key={index}>{item}</Item>)}</List>}
        <Button href={link}>{buttonText}
          <img src={facebookLogo} alt='facebook logo' />
        </Button>
      </div>
    </Fade>
  </Wrapper>

export default FacebookLinkTemplate